(function(){ function __recoverOld(){
// White dropdown on white-background pages
  (function() {
    var p = window.location.pathname;
    if (p.match(/\/pages\/(contact|shipping|about|returns-reparations)/) || p.match(/\/policies\//)) {
      document.body.classList.add('white-dropdown');
    }
  })();

  // Miista-style collection heading: title + description overlay (collection pages only)
  (function() {
    const collHandle = window.location.pathname.match(/\/collections\/([^/?]+)/)?.[1];
    if (!collHandle) return;
    const h1 = document.querySelector('#MainContent h1');
    if (!h1) return;
    const textBlock = h1.closest('.text-block, .spacing-style');
    const section = textBlock?.closest('.section');
    if (!section) return;
    section.classList.add('collection-heading-wrapper');
    fetch('/collections/' + collHandle + '.json')
      .then(r => r.json())
      .then(data => {
        const desc = data?.collection?.body_html?.replace(/<[^>]+>/g, '').trim();
        if (desc) {
          const overlay = document.createElement('div');
          overlay.className = 'collection-description-overlay';
          overlay.textContent = desc;
          section.appendChild(overlay);
        }
      })
      .catch(() => {});
  })();

  // Miista-style contact page
  (function() {
    if (!window.location.pathname.match(/\/pages\/contact/i)) return;
    if (document.querySelector('[data-recovery-page]')) return;
    document.body.classList.add('white-dropdown');
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const sections = main.querySelectorAll('.section');
    sections.forEach(s => s.style.display = 'none');
    const wrapper = document.createElement('div');
    wrapper.className = 'contact-page-custom';
    wrapper.innerHTML = '<p class="contact-intro">We love connecting with the people who wear our pieces. Reach out about anything from sizing and care to collaborations. Every message matters to us.</p>'
      + '<h2 class="contact-title">Contact us</h2>'
      + '<div class="contact-card-wrapper">'
      + '<div class="contact-card">'
      + '<div class="card-tagline">We would love to be in contact with you</div>'
      + '<div class="card-row"><span>Simone Sigfredsen</span><span>Founder / Creative Director</span></div>'
      + '<div class="card-brand">Sigfredsen Studio</div>'
      + '<div class="card-bottom"><a href="mailto:info@sigfredsenstudio.com">info@sigfredsenstudio.com</a><span>sigfredsenstudio.com</span></div>'
      + '</div>'
      + '</div>'
      + '<div class="contact-body">'
      + '<div class="contact-sidebar">'
      + '<button class="active" data-tab="customer-service">CUSTOMER SERVICE</button>'
      + '<button data-tab="collaborations">COLLABORATIONS</button>'
      + '</div>'
      + '</div>'
      + '<div class="contact-content">'
      + '<div class="contact-section active" id="tab-customer-service">'
      + '<p>For any customer service or product inquiries please contact:</p>'
      + '<p><a href="mailto:info@sigfredsenstudio.com">info@sigfredsenstudio.com</a></p>'
      + '<hr>'
      + '<p>Please allow 1–2 working days for our small team to respond to any email queries &amp; requests.</p>'
      + '</div>'
      + '<div class="contact-section" id="tab-collaborations">'
      + '<p>For press inquiries, lookbook requests, or editorial collaborations:</p>'
      + '<p><a href="mailto:info@sigfredsenstudio.com">info@sigfredsenstudio.com</a></p>'
      + '</div>'
      + '</div>'
      + '</div>';
    main.appendChild(wrapper);
    var fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap';
    document.head.appendChild(fontLink);
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.style.position = 'absolute';
    svg.innerHTML = '<filter id="rough-edges"><feTurbulence type="fractalNoise" baseFrequency="0.035" numOctaves="5" result="noise"/><feDisplacementMap in="SourceGraphic" in2="noise" scale="6" xChannelSelector="R" yChannelSelector="G"/></filter>';
    document.body.appendChild(svg);
    wrapper.querySelectorAll('.contact-sidebar button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        wrapper.querySelectorAll('.contact-sidebar button').forEach(function(b) { b.classList.remove('active'); });
        wrapper.querySelectorAll('.contact-section').forEach(function(s) { s.classList.remove('active'); });
        btn.classList.add('active');
        var tab = wrapper.querySelector('#tab-' + btn.dataset.tab);
        if (tab) tab.classList.add('active');
      });
    });
  })();

  // Shipping page custom layout
  (function() {
    if (window.location.pathname !== '/pages/shipping') return;
    if (document.querySelector('[data-recovery-page]')) return;
    document.body.classList.add('white-dropdown');
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const sections = main.querySelectorAll('.section');
    sections.forEach(s => s.style.display = 'none');
    const wrapper = document.createElement('div');
    wrapper.className = 'contact-page-custom';
    wrapper.innerHTML = '<p class="contact-intro">Every piece is handmade in our studio in Copenhagen, so please allow a little extra time for your order to be crafted and shipped.</p>'
      + '<h2 class="contact-title">Shipping</h2>'
      + '<div class="shipping-content">'
      + '<div class="shipping-block">'
      + '<h3>DELIVERY TIME</h3>'
      + '<p>Because each piece is made to order by hand in our Copenhagen studio, delivery takes approximately 2–5 weeks. We take our time to ensure every detail is right.</p>'
      + '</div>'
      + '<div class="shipping-block">'
      + '<h3>STUDIO PICKUP</h3>'
      + '<p>Want to skip shipping? You are welcome to pick up your order directly from our studio in København K. Simply select studio pickup at checkout or send us an email to arrange a time.</p>'
      + '</div>'
      + '<div class="shipping-block">'
      + '<h3>TRACKING</h3>'
      + '<p>Once your order has shipped, you will receive an email with your tracking number.</p>'
      + '</div>'
      + '<div class="shipping-block">'
      + '<h3>QUESTIONS</h3>'
      + '<p>For any shipping inquiries, please contact us at <a href="mailto:info@sigfredsenstudio.com">info@sigfredsenstudio.com</a></p>'
      + '</div>'
      + '</div>';
    main.appendChild(wrapper);
  })();

  // About page custom layout
  (function() {
    if (window.location.pathname !== '/pages/about') return;
    if (document.querySelector('[data-recovery-page]')) return;
    document.body.classList.add('white-dropdown');
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const sections = main.querySelectorAll('.section');
    sections.forEach(s => s.style.display = 'none');
    const wrapper = document.createElement('div');
    wrapper.className = 'contact-page-custom';
    wrapper.innerHTML = '<p class="contact-intro">Sigfredsen Studio is a Copenhagen based brand. Every item is handcrafted in our studio in Copenhagen.</p>'
      + '<h2 class="contact-title">About</h2>'
      + '<div class="about-content">'
      + '<p>Sigfredsen Studio was founded in 2025 by Creative Director Simone Elinor Sigfredsen, born out of her small apartment in Østerbro, Copenhagen.</p>'
      + '<p>Today, all of our creations are designed and drafted in our studio near the lakes in the centre of Copenhagen.</p>'
      + '<p>Inspired by vintage clothing, Sigfredsen Studio was created to make special pieces that move between occasions, dressed up or down depending on how you style them. We care deeply about comfort and fit, so that every piece is one you want to reach for again and again.</p>'
      + '</div>';
    main.appendChild(wrapper);
  })();

  // Privacy Policy page custom layout
  (function() {
    if (window.location.pathname !== '/policies/privacy-policy') return;
    const main = document.querySelector('#MainContent');
    if (!main) return;
    var policyBody = main.querySelector('.policy-body, .rte, [class*="policy"]');
    var bodyHTML = policyBody ? policyBody.innerHTML : '';
    var existing = main.querySelectorAll('.shopify-section, .section, .policy-header, [class*="policy"]');
    existing.forEach(function(el) { el.style.display = 'none'; });
    var allChildren = main.children;
    for (var i = 0; i < allChildren.length; i++) {
      if (!allChildren[i].classList.contains('contact-page-custom')) {
        allChildren[i].style.display = 'none';
      }
    }
    var wrapper = document.createElement('div');
    wrapper.className = 'contact-page-custom';
    wrapper.innerHTML = '<p class="contact-intro">Your privacy matters to us. Here is how we handle your data.</p>'
      + '<h2 class="contact-title">Privacy Policy</h2>'
      + '<div class="policy-content">' + bodyHTML + '</div>';
    main.appendChild(wrapper);
  })();

  // Returns page — inject intro text above title
  (function() {
    if (window.location.pathname !== '/pages/returns-reparations') return;
    if (document.querySelector('.returns-intro[data-recovery-page]')) return;
    document.body.classList.add('white-dropdown');
    var h1 = document.querySelector('#MainContent h1');
    if (!h1) return;
    var intro = document.createElement('p');
    intro.className = 'returns-intro';
    intro.textContent = 'Every piece is crafted with care, and we want you to love what you wear. If something isn’t quite right, we’re here to make it right.';
    var parent = h1.closest('.text-block, .spacing-style') || h1.parentElement;
    parent.insertBefore(intro, h1);
    if (!document.getElementById('rough-edges')) {
      var svgNS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('width', '0');
      svg.setAttribute('height', '0');
      svg.style.position = 'absolute';
      svg.innerHTML = '<filter id="rough-edges"><feTurbulence type="fractalNoise" baseFrequency="0.035" numOctaves="5" result="noise"/><feDisplacementMap in="SourceGraphic" in2="noise" scale="4" xChannelSelector="R" yChannelSelector="G"/></filter>';
      document.body.appendChild(svg);
    }
  })();

  // Sale collection — hide default empty state, show custom message + signup form
  (function() {
    if (!window.location.pathname.match(/\/collections\/sale/i)) return;
    document.body.classList.add('sale-page-active');
    var products = document.querySelectorAll('.product-card, .grid__item, [class*="product-card"]');
    if (products.length > 0) return;
    var main = document.querySelector('#MainContent');
    if (!main) return;
    var empty = main.querySelector('[class*="no-products"], [class*="empty"], [class*="collection-empty"]');
    if (!empty) {
      var all = main.querySelectorAll('h2, h1, p');
      all.forEach(function(el) {
        if (el.textContent.includes('No products found') || el.textContent.includes('Try using fewer')) {
          el.style.display = 'none';
        }
      });
    } else {
      empty.style.display = 'none';
    }
    var msg = document.createElement('p');
    msg.className = 'collection-empty-message';
    msg.textContent = 'Nothing on sale right now. Check back soon or sign up to be the first to know.';
    var title = main.querySelector('h1, h2');
    if (title) {
      title.parentNode.insertBefore(msg, title);
    } else {
      main.appendChild(msg);
    }
    var label = document.createElement('p');
    label.className = 'sale-signup-label';
    label.textContent = 'Get an email when we have the next archive sale';
    main.appendChild(label);
    var form = document.createElement('div');
    form.className = 'sale-signup-form';
    form.innerHTML = '<input type="email" placeholder="Your email" id="sale-email" /><button type="button" id="sale-subscribe">Notify me</button>';
    main.appendChild(form);
    document.getElementById('sale-subscribe').addEventListener('click', function() {
      var email = document.getElementById('sale-email').value;
      if (!email || !email.includes('@')) return;
      this.textContent = 'Subscribed!';
      this.style.background = '#000';
      this.style.color = '#fff';
      document.getElementById('sale-email').disabled = true;
      this.disabled = true;
    });
  })();

  // Dresses collection — coming soon message + signup form
  (function() {
    if (!window.location.pathname.match(/\/collections\/dresses/i)) return;
    document.body.classList.add('dresses-page-active');
    var products = document.querySelectorAll('.product-card, .grid__item, [class*="product-card"]');
    if (products.length > 0) return;
    var main = document.querySelector('#MainContent');
    if (!main) return;
    var empty = main.querySelector('[class*="no-products"], [class*="empty"], [class*="collection-empty"]');
    if (!empty) {
      var all = main.querySelectorAll('h2, h1, p');
      all.forEach(function(el) {
        if (el.textContent.includes('No products found') || el.textContent.includes('Try using fewer')) {
          el.style.display = 'none';
        }
      });
    } else {
      empty.style.display = 'none';
    }
    var msg = document.createElement('p');
    msg.className = 'collection-empty-message';
    msg.textContent = 'Our first dresses are being crafted in the studio. Sign up to be the first to see them.';
    var title = main.querySelector('h1, h2');
    if (title) {
      title.parentNode.insertBefore(msg, title);
    } else {
      main.appendChild(msg);
    }
    var label = document.createElement('p');
    label.className = 'sale-signup-label';
    label.textContent = 'Get notified when dresses drop';
    main.appendChild(label);
    var form = document.createElement('div');
    form.className = 'sale-signup-form';
    form.innerHTML = '<input type="email" placeholder="Your email" id="dresses-email" /><button type="button" id="dresses-subscribe">Notify me</button>';
    main.appendChild(form);
    document.getElementById('dresses-subscribe').addEventListener('click', function() {
      var email = document.getElementById('dresses-email').value;
      if (!email || !email.includes('@')) return;
      this.textContent = 'Subscribed!';
      this.style.background = '#000';
      this.style.color = '#fff';
      document.getElementById('dresses-email').disabled = true;
      this.disabled = true;
    });
  })();

  function stripZeros(root) {
    root.querySelectorAll('.cart-items__price, .cart-items__unit-price-wrapper, .cart-totals__total-value, .cart-items__variant-price, [class*="price"]').forEach(el => {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while (node = walker.nextNode()) {
        if (node.textContent.includes(',00')) {
          node.textContent = node.textContent.replace(/,00/g, '');
        }
      }
    });
  }
  const cart = document.getElementById('cart-drawer');
  if (cart) {
    const obs = new MutationObserver(() => stripZeros(cart));
    obs.observe(cart, { childList: true, subtree: true, characterData: true });
    document.addEventListener('theme-drawer:open', () => setTimeout(() => stripZeros(cart), 100));
  }

  // Cart drawer dark overlay
  const overlay = document.createElement('div');
  overlay.className = 'cart-drawer-overlay';
  overlay.style.opacity = '0';
  overlay.style.visibility = 'hidden';
  overlay.style.pointerEvents = 'none';
  document.body.appendChild(overlay);

  function showOverlay() {
    overlay.getAnimations().forEach(a => a.cancel());
    overlay.style.visibility = 'visible';
    overlay.style.pointerEvents = 'auto';
    overlay.style.opacity = '1';
  }
  function hideOverlay() {
    overlay.getAnimations().forEach(a => a.cancel());
    overlay.style.opacity = '0';
    overlay.style.visibility = 'hidden';
    overlay.style.pointerEvents = 'none';
  }

  overlay.addEventListener('click', () => {
    const drawer = document.getElementById('cart-drawer');
    drawer?.querySelector('[on\\:click="#cart-drawer/close"]')?.click();
  });


  document.addEventListener('theme-drawer:open', (e) => {
    if (document.getElementById('cart-drawer')?.hasAttribute('open')) {
      showOverlay();
    }
  });

  document.addEventListener('theme-drawer:close', () => {
    hideOverlay();
  });

  // Ensure cart bubble dot shows immediately when items are added
  let bubbleUpdating = false;
  function ensureBubbleDot() {
    if (bubbleUpdating) return;
    const bubble = document.querySelector('.cart-bubble');
    if (!bubble) return;
    const countEl = bubble.querySelector('.cart-bubble__text-count');
    const count = countEl ? parseInt(countEl.textContent.trim(), 10) : 0;
    bubbleUpdating = true;
    if (count > 0) {
      bubble.classList.remove('visually-hidden');
    } else {
      bubble.classList.add('visually-hidden');
    }
    bubbleUpdating = false;
  }
  const bubbleEl = document.querySelector('.cart-bubble');
  if (bubbleEl) {
    new MutationObserver(ensureBubbleDot).observe(bubbleEl, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('cart:change', ensureBubbleDot);
  document.addEventListener('cart-lines:update', ensureBubbleDot);
  document.addEventListener('theme-drawer:open', ensureBubbleDot);

  // Inject extra CSS at end of <head> so it loads last and wins specificity.
  const cartStyleId = 'cart-drawer-custom-style';
  if (!document.getElementById(cartStyleId)) {
    const s = document.createElement('style');
    s.id = cartStyleId;
    s.textContent = [
      "#cart-drawer .cart-items__table-row,",
      "#cart-drawer .cart-items__table-row--full-width-variants {",
      "  display: grid !important;",
      "  grid-template-columns: 60px minmax(0, 1fr) !important;",
      "  grid-template-areas:",
      "    'media details'",
      "    'media variants'",
      "    'media unit_price'",
      "    'media quantity'",
      "    'media error' !important;",
      "  column-gap: 14px !important;",
      "  align-items: start !important;",
      "}",
      "#cart-drawer .cart-items__details { display: contents !important; }",
      "#cart-drawer .cart-items__product-info { grid-area: details !important; }",
      "#cart-drawer .cart-items__variants-wrapper { grid-area: variants !important; }",
      "#cart-drawer .cart-items__unit-price-wrapper { grid-area: unit_price !important; }",
      "#cart-drawer .cart-items__media { grid-area: media !important; width: 60px !important; max-width: 60px !important; }",
      "#cart-drawer .cart-items__quantity { grid-area: quantity !important; }",
      "#cart-drawer td.cart-items__price { display: none !important; }",
      "#cart-drawer .cart-items__media-container { width: 60px !important; max-width: 60px !important; }",
      "#cart-drawer .cart-items__variant { display: inline !important; }",
      "#cart-drawer .cart-items__variant dd { display: inline !important; margin: 0 !important; }",
      "#cart-drawer dl.cart-items__variants { margin: 0 !important; }",
      "#cart-drawer .cart-items__unit-price-wrapper::before { content: 'PRICE: ' !important; display: inline !important; font-size: 11px !important; font-weight: 400 !important; letter-spacing: 0.06em !important; color: #000 !important; }",
      "#cart-drawer .cart-totals__tax-note { text-align: left !important; }",
      ".cart__checkout-button { width: 100% !important; }",
    ].join('\n');
    document.head.appendChild(s);
  }

  // Close button — event delegation so it works after any DOM replacement
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#cart-drawer .theme-drawer__close-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var cd = document.getElementById('cart-drawer');
    if (!cd) return;
    var dlg = cd.querySelector('dialog');
    if (dlg) {
      dlg.classList.remove('theme-drawer__dialog--opening');
      dlg.classList.add('theme-drawer__dialog--closing');
      dlg.addEventListener('animationend', function handler() {
        dlg.removeEventListener('animationend', handler);
        dlg.classList.remove('theme-drawer__dialog--closing');
        dlg.removeAttribute('open');
        dlg.style.display = '';
        cd.removeAttribute('open');
      }, { once: true });
    }
    hideOverlay();
    document.dispatchEvent(new CustomEvent('theme-drawer:close'));
  }, true);

  // Strip zeros whenever the cart drawer content changes
  var cartEl = document.getElementById('cart-drawer');
  if (cartEl) {
    new MutationObserver(function() { stripZeros(cartEl); })
      .observe(cartEl, { childList: true, subtree: true, characterData: true });
  }

  // Fix empty→non-empty: data-skip-node-update blocks the theme's morph,
  // so we must manually fetch fresh section HTML and replace the content.
  async function fixEmptyDrawerAfterAdd() {
    if (!cartEl) return;
    var inner = cartEl.querySelector('.cart-drawer__inner');
    if (!inner || !inner.classList.contains('cart-drawer--empty')) return;

    // Wait until cart actually has items
    var cartData;
    for (var i = 0; i < 5; i++) {
      await new Promise(function(r) { setTimeout(r, 150); });
      cartData = await fetch('/cart.js').then(function(r) { return r.json(); });
      if (cartData.item_count > 0) break;
    }
    if (!cartData || cartData.item_count === 0) return;

    // Fetch fresh drawer HTML
    var resp = await fetch('/?sections=cart-drawer-section');
    var json = await resp.json();
    var html = json['cart-drawer-section'];
    if (!html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');

    // Inject stylesheets from the section response (mirrors morphSection injectStylesheet)
    doc.querySelectorAll('style, link[rel="stylesheet"]').forEach(function(el) {
      var clone = el.cloneNode(true);
      document.head.appendChild(clone);
    });

    var newInner = doc.querySelector('.cart-drawer__inner');
    if (!newInner) return;

    inner.replaceWith(newInner);
    stripZeros(cartEl);

    // Open the drawer
    var dlg = cartEl.querySelector('dialog');
    if (dlg && !dlg.hasAttribute('open')) {
      cartEl.setAttribute('open', '');
      dlg.setAttribute('open', '');
      dlg.style.display = 'flex';
      dlg.classList.add('theme-drawer__dialog--opening');
      document.dispatchEvent(new CustomEvent('theme-drawer:open'));
    }
    showOverlay();
  }

  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var inner = cartEl && cartEl.querySelector('.cart-drawer__inner');
      if (inner && inner.classList.contains('cart-drawer--empty')) {
        fixEmptyDrawerAfterAdd();
      }
    });
  });

  document.addEventListener('theme-drawer:open', function() {
    setTimeout(function() {
      var inner = cartEl && cartEl.querySelector('.cart-drawer__inner');
      if (inner && inner.classList.contains('cart-drawer--empty')) {
        fixEmptyDrawerAfterAdd();
      }
    }, 200);
  });  try { document.querySelectorAll('accordion-custom').forEach(function(a){ var s=a.querySelector('summary,[class*="heading"]'); if(/description/i.test(((s?s.textContent:a.textContent)||'').slice(0,40))){var d=a.querySelector('details'); if(d)d.open=true;} }); } catch(e){}
} if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',__recoverOld);}else{__recoverOld();} })();
